<template functional>
  <div class="activity-details">
    <template v-if="!props.hideActivityDetails">
      <div class="mt-16 detail-list">
        <div
          :class="{
            changed: !!props.diffItems && props.diffItems.hasOwnProperty('name')
          }"
        >
          <h5 class="header-color fs-14 mb-4">Title</h5>
          <p class="color_666669 fs-14">{{ props.activity.name }}</p>
        </div>

        <div
          :class="{
            changed: !!props.diffItems && props.diffItems.hasOwnProperty('abbreviation')
          }"
        >
          <h5 class="header-color fs-14 mb-4">Abbreviation</h5>
          <p class="color_666669 fs-14">{{ props.activity.abbreviation }}</p>
        </div>

        <div
          :class="{
            changed: !!props.diffItems && props.diffItems.hasOwnProperty('therapeuticArea')
          }"
        >
          <h5 class="header-color fs-14 mb-4">Therapeutic area</h5>
          <p class="color_666669 fs-14">{{ props.activity.therapeuticArea }}</p>
        </div>

        <div
          :class="{
            changed: !!props.diffItems && props.diffItems.hasOwnProperty('therapeuticIndication')
          }"
        >
          <h5 class="header-color fs-14 mb-4">Therapeutic indication</h5>
          <p class="color_666669 fs-14">
            {{ props.activity.therapeuticIndication }}
          </p>
        </div>

        <div
          :class="{
            changed: !!props.diffItems && props.diffItems.hasOwnProperty('completedBy')
          }"
        >
          <h5 class="header-color fs-14 mb-4">Permissions</h5>
          <p class="color_666669 fs-14">
            Complete By:
            <template v-for="(canComplete, index) in props.activity.completedBy">
              <span :key="index"> {{ canComplete }}<template v-if="index < props.activity.completedBy.length - 1">, </template> </span>
            </template>
          </p>
        </div>
        <div
          :class="{
            changed: !!props.diffItems && props.diffItems.hasOwnProperty('canViewBy')
          }"
        >
          <p class="color_666669 fs-14">
            Can View:
            <template v-for="(canViewBy, index) in props.activity.canViewBy">
              <span :key="index"> {{ canViewBy }}<template v-if="index < props.activity.canViewBy.length - 1">, </template> </span>
            </template>
          </p>
        </div>

        <div
          :class="{
            changed: !!props.diffItems && props.diffItems.hasOwnProperty('author')
          }"
        >
          <h5 class="header-color fs-14 mb-4">Author</h5>
          <p class="color_666669 fs-14">{{ props.activity.author }}</p>
        </div>

        <div
          :class="{
            changed: !!props.diffItems && props.diffItems.hasOwnProperty('copyright')
          }"
        >
          <h5 class="header-color fs-14 mb-4">Copyright</h5>
          <p class="color_666669 fs-14">{{ props.activity.copyright }}</p>
        </div>

        <div
          :class="{
            changed: !!props.diffItems && props.diffItems.hasOwnProperty('language')
          }"
        >
          <h5 class="header-color fs-14 mb-4">Available Languages</h5>
          <p class="color_666669 fs-14">
            <template v-for="(lang, index) in props.activity.language">
              <span :key="index"> {{ lang.display_name }}<template v-if="index < props.activity.language.length - 1">, </template> </span>
            </template>
          </p>
        </div>

        <div
          :class="{
            changed: !!props.diffItems && props.diffItems.hasOwnProperty('groupName')
          }"
        >
          <h5 class="header-color fs-14 mb-4">Groups</h5>
          <p class="color_666669 fs-14">{{ props.activity.groupName }}</p>
        </div>

        <div
          :class="{
            changed: !!props.diffItems && props.diffItems.hasOwnProperty('timeToComplete')
          }"
        >
          <h5 class="header-color fs-14 mb-4">Approximate time to complete</h5>
          <p class="color_666669 fs-14">{{ props.activity.timeToComplete }} mins</p>
        </div>
      </div>
    </template>

    <template v-if="!props.hideActivitySettings">
      <div class="activity-settings mt-16">
        <div
          class="d-flex justify-content-between"
          :class="{
            changed: !!props.diffItems && props.diffItems.hasOwnProperty('canScoreResponses')
          }"
        >
          <p class="header-color fs-14">Ability to score responses</p>
          <p class="color_666669 fs-14">
            {{ props.activity.canScoreResponses === true ? "Enabled" : "Disabled" }}
          </p>
        </div>
        <div
          class="d-flex justify-content-between"
          :class="{
            changed: !!props.diffItems && props.diffItems.hasOwnProperty('allowDataEditChecks')
          }"
        >
          <p class="header-color fs-14">Allow site users to edit responses</p>
          <p class="color_666669 fs-14">
            {{ props.activity.allowDataEditChecks === true ? "Enabled" : "Disabled" }}
          </p>
        </div>
        <div
          class="d-flex justify-content-between"
          :class="{
            changed: !!props.diffItems && props.diffItems.hasOwnProperty('watchEnabled')
          }"
        >
          <p class="header-color fs-14">Available for Apple Watch app</p>
          <p class="color_666669 fs-14">
            {{ props.activity.watchEnabled === true ? "Enabled" : "Disabled" }}
          </p>
        </div>
        <div
          class="d-flex justify-content-between"
          :class="{
            changed: !!props.diffItems && props.diffItems.hasOwnProperty('prePopulationEnabled')
          }"
        >
          <p class="header-color fs-14">Re-population with prior responses</p>
          <p class="color_666669 fs-14">
            {{ props.activity.prePopulationEnabled === true ? "Enabled" : "Disabled" }}
          </p>
        </div>
        <div
          class="d-flex justify-content-between"
          :class="{
            changed: !!props.diffItems && props.diffItems.hasOwnProperty('customParticipantMessaging')
          }"
        >
          <p class="header-color fs-14">Custom Participant Message</p>
          <p class="color_666669 fs-14">
            {{ props.activity.customParticipantMessaging === true ? "Enabled" : "Disabled" }}
          </p>
        </div>
        <div
          class="d-flex justify-content-between"
          :class="{
            changed: !!props.diffItems && props.diffItems.hasOwnProperty('hideNumericLabels')
          }"
        >
          <p class="header-color fs-14">Hide Step Numbers</p>
          <p class="color_666669 fs-14">
            {{ props.activity.hideNumericLabels === true ? "Enabled" : "Disabled" }}
          </p>
        </div>
        <div
          class="d-flex justify-content-between"
          :class="{
            changed: !!props.diffItems && props.diffItems.hasOwnProperty('allowSaveProgress')
          }"
        >
          <p class="header-color fs-14">Allow participant to save progress</p>
          <p class="color_666669 fs-14">
            {{ props.activity.allowSaveProgress === true ? "Enabled" : "Disabled" }}
          </p>
        </div>
        <div
          class="d-flex justify-content-between"
          :class="{
            changed: !!props.diffItems && props.diffItems.hasOwnProperty('enableProgressIndicator')
          }"
        >
          <p class="header-color fs-14">Enable progress indicators</p>
          <p class="color_666669 fs-14">
            {{ props.activity.enableProgressIndicator === true ? "Enabled" : "Disabled" }}
          </p>
        </div>
        <div
          class="d-flex justify-content-between"
          :class="{
            changed: !!props.diffItems && props.diffItems.hasOwnProperty('allowDevicesForCompletion')
          }"
        >
          <p class="header-color fs-14">Define devises for completion</p>
          <p class="color_666669 fs-14">
            {{ props.activity.allowDevicesForCompletion === true ? "Enabled" : "Disabled" }}
          </p>
        </div>
        <div
          class="d-flex justify-content-between"
          :class="{
            changed: !!props.diffItems && props.diffItems.hasOwnProperty('allowPreviousResponses')
          }"
        >
          <p class="header-color fs-14">Allow previous responses to be show</p>
          <p class="color_666669 fs-14">
            {{ props.activity.allowPreviousResponses === true ? "Enabled" : "Disabled" }}
          </p>
        </div>
        <div
          class="d-flex justify-content-between"
          :class="{
            changed: !!props.diffItems && props.diffItems.hasOwnProperty('dataChecksForResponses')
          }"
        >
          <p class="header-color fs-14">Enable data checks for responses</p>
          <p class="color_666669 fs-14">
            {{ props.activity.dataChecksForResponses === true ? "Enabled" : "Disabled" }}
          </p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "ActivityDetails",

  props: {
    activity: {
      type: Object,
      default: null
    },
    hideActivityDetails: {
      type: Boolean,
      default: false
    },
    hideActivitySettings: {
      type: Boolean,
      default: false
    },
    diffItems: {
      type: Object,
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
.activity-details {
  h5,
  p {
    font-weight: bold;
  }

  .detail-list {
    > div {
      margin-bottom: 16px;

      p {
        display: inline-block;
        margin-bottom: 0px;
      }
      &.changed {
        p {
          background: rgba(249, 233, 120, 0.4);
        }
      }
    }
  }

  .header-color {
    color: #979797;
  }

  .activity-settings {
    width: 100%;
    max-width: 374px;

    p {
      margin-bottom: 0px;
    }

    > div {
      margin-bottom: 16px;
      &.changed {
        p:last-child {
          background: rgba(249, 233, 120, 0.4);
        }
      }
    }
  }

  .changed {
    position: relative;

    &:before {
      content: "";
      position: absolute;
      height: 100%;
      width: 4px;
      left: -8px;
      background: rgba(249, 233, 120, 1);
    }
  }
}
</style>
